export default function TobaccoConverter(value) {
    switch (value) {
        case "Within the last year":
            return "Within the last year";
        case "Within the last 1 to 3 years":
            return "Within the last 13-36 months";
        case "Within the last 3 to 5 years":
            return "Over 36 months";
        case "Over 5 years ago":
            return "Over 36 months";
        case "Never":
            return "Never";
        default:
            return "";
    }
}